import styled from 'styled-components';
import { WidgetTitle } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function Header() {
  const {
    widgetTitle,
    widgetTitleTitle,
    widgetTitleCaption,
    widgetTitleTitleColor,
    widgetTitleTitleTextStyle,
    widgetTitleCaptionTextStyle,
    widgetTitleLinksColor,
    widgetTitleCaptionColor,
    widgetTitleAlignment
  } = useSettings();

  return (
    <StyledWidgetTitle
      enabled={widgetTitle}
      title={widgetTitleTitle}
      caption={widgetTitleCaption}
      alignment={widgetTitleAlignment}
      titleColor={widgetTitleTitleColor}
      captionColor={widgetTitleCaptionColor}
      linksColor={widgetTitleLinksColor}
      titleTextStyle={widgetTitleTitleTextStyle}
      captionTextStyle={widgetTitleCaptionTextStyle}
      bottomOffset={0}
    />
  );
}

const StyledWidgetTitle = styled(WidgetTitle)`
  width: 100%;
  word-wrap: break-word;
`;
